module.exports = __webpack_public_path__ + "static/img/phone_p.b939f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_p.png
// module id = iQco
// module chunks = 1